export default __webpack_public_path__ + "static/media/merchbutton.561538dd.webp";